import { render, staticRenderFns } from "./PollView.vue?vue&type=template&id=0f4b76c3&"
import script from "./PollView.vue?vue&type=script&lang=ts&"
export * from "./PollView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports